import { InfoOutlined } from '@mui/icons-material';
import { Box, styled } from '@mui/material';

export const LabelContainer = styled(Box)`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledInfoIcon = styled(InfoOutlined)`
  display: block;
`;
